import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

export default function ConsultationQualiteAmorceurResine() {
  const { t, ui } = useI18n();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [search, setSearch] = useState("");
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();

  const safeParse = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    try { return JSON.parse(val); } catch { return []; }
  };

  useEffect(() => {
    (async () => {
      try {
        const r = await apiFetch("/api/qualite/mpar/list");
        const j = await r.json();
        const cleaned = (j.items || j || []).map(item => ({
          ...item,
          Samples: safeParse(item.Samples),
          SamplesComments: safeParse(item.SamplesComments),
        }));
        setRows(cleaned);
        setLoading(false);
      } catch (e) {
        setErr("Erreur de chargement");
        setLoading(false);
      }
    })();
  }, []);

  const filtered = rows.filter(r => {
    const s = search.toLowerCase();
    return r.Operator?.toLowerCase().includes(s) ||
      r.Fournisseur?.toLowerCase().includes(s) ||
      r.LotFournisseur?.toLowerCase().includes(s);
  });

  const statCount = {
    total: rows.length,
    nok: rows.filter(r => Number(r.PliesNOK) > 0).length,
    ok: rows.filter(r => Number(r.PliesNOK) === 0).length,
  };

  return (
    <>
      <style>{globalCSS}</style>

      <div style={S.page}>
        <MenuBar active="qualite" />

        <div style={S.wrap}>

          {/* ── HEADER ── */}
          <div style={S.header}>
            <div>
              <div style={S.headerTitle}>Qualité MP — Liant / Amorceur</div>
              <div style={S.headerSub}>Consultation des analyses matière première</div>
            </div>
            <div style={S.statsRow}>
              <div style={S.statCard}>
                <div style={S.statNum}>{statCount.total}</div>
                <div style={S.statLabel}>Total lots</div>
              </div>
              <div style={{ ...S.statCard, borderColor: "#4ade80" }}>
                <div style={{ ...S.statNum, color: "#4ade80" }}>{statCount.ok}</div>
                <div style={S.statLabel}>Sans défaut</div>
              </div>
              <div style={{ ...S.statCard, borderColor: "#f87171" }}>
                <div style={{ ...S.statNum, color: "#f87171" }}>{statCount.nok}</div>
                <div style={S.statLabel}>Avec NOK</div>
              </div>
            </div>
          </div>

          {/* ── PANEL ── */}
          <div style={S.panel}>

            {/* ── SEARCH ── */}
            <div style={S.searchWrap}>
              <span style={S.searchIcon}>🔍</span>
              <input
                className="woodoo-input"
                placeholder="Rechercher par opérateur, fournisseur ou lot..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={S.searchInput}
              />
              {search && (
                <button style={S.searchClear} onClick={() => setSearch("")}>✕</button>
              )}
            </div>

            <div style={S.resultCount}>
              <span style={S.resultDot} />
              {filtered.length} résultat(s) sur {rows.length}
            </div>

            {loading && <div style={S.loading}><span className="woodoo-spin">⟳</span> {ui("Chargement…")}</div>}
            {err && <div style={S.errMsg}>{err}</div>}

            {/* ── TABLE ── */}
            {!loading && (
              <div style={S.tableWrap} className="woodoo-scroll">
                <table style={S.table}>
                  <thead>
                    <tr>
                      {["#", "Date", "Fournisseur", "Lot", "Opérateur", "Liant (kg)", "Amorceur (kg)", "NOK", "Détails", "Modifier"].map(h => (
                        <th key={h} className="woodoo-th" style={S.th}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((row, i) => (
                      <tr key={row.index} className="woodoo-tr" style={i % 2 === 0 ? S.trEven : S.trOdd}>
                        <td style={S.tdIndex}>{row.index}</td>
                        <td style={S.td}>{row.Date}</td>
                        <td style={{ ...S.td, fontWeight: 600 }}>{row.Fournisseur}</td>
                        <td style={{ ...S.td, ...S.tdLot }}>{row.LotFournisseur}</td>
                        <td style={S.td}>{row.Operator}</td>
                        <td style={S.td}>{row.QuantiteResine}</td>
                        <td style={S.td}>{row.QuantiteAmorceur}</td>
                        <td style={S.td}>
                          <span style={Number(row.PliesNOK) > 0 ? S.nokBadge : S.okBadge}>
                            {Number(row.PliesNOK) > 0 ? `⚠ ${row.PliesNOK}` : "✓ 0"}
                          </span>
                        </td>
                        <td style={S.td}>
                          <button className="woodoo-voir" style={S.voirBtn} onClick={() => setDetails(row)}>
                            Voir →
                          </button>
                        </td>
                        <td style={S.td}>
                          <button className="woodoo-edit" style={S.editBtn}
                            onClick={() => navigate("/qualite/mpar/form", { state: { item: row } })}>
                            ✏ Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* ── MODAL ── */}
        {details && (
          <div style={S.backdrop} onClick={() => setDetails(null)}>
            <div style={S.modal} onClick={e => e.stopPropagation()}>

              {/* Header */}
              <div style={S.modalHeader}>
                <div>
                  <div style={S.modalTitle}>Détails du lot</div>
                  <div style={S.modalSub}>
                    {details.LotFournisseur} · {details.Fournisseur} · {details.Date}
                  </div>
                </div>
                <button style={S.modalClose} onClick={() => setDetails(null)}>✕</button>
              </div>

              {/* Infos rapides */}
              <div style={S.infoRow}>
                <div style={S.infoChip}>
                  <span style={S.infoChipLabel}>👤 Opérateur</span>
                  <span style={S.infoChipVal}>{details.Operator || "—"}</span>
                </div>
                <div style={S.infoChip}>
                  <span style={S.infoChipLabel}>🧪 Liant</span>
                  <span style={S.infoChipVal}>{details.QuantiteResine || "—"} kg</span>
                </div>
                <div style={S.infoChip}>
                  <span style={S.infoChipLabel}>⚗️ Amorceur</span>
                  <span style={S.infoChipVal}>{details.QuantiteAmorceur || "—"} kg</span>
                </div>
                <div style={{ ...S.infoChip, borderColor: Number(details.PliesNOK) > 0 ? "#f87171" : "#4ade80" }}>
                  <span style={S.infoChipLabel}>NOK</span>
                  <span style={{ ...S.infoChipVal, color: Number(details.PliesNOK) > 0 ? "#f87171" : "#4ade80" }}>
                    {details.PliesNOK || 0}
                  </span>
                </div>
              </div>

              {/* Mesures techniques */}
              <div style={S.sectionTitle}>Mesures techniques</div>
              <div style={S.tableWrap} className="woodoo-scroll">
                <table style={{ ...S.table, fontSize: 13 }}>
                  <thead>
                    <tr>
                      {["Sample", "Temp °C", "Viscosité", "Masse vol.", "% Eau", "Visuel"].map(h => (
                        <th key={h} style={S.modalTh}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {details.Samples?.map((s, i) => (
                      <tr key={i} className="woodoo-tr" style={i % 2 === 0 ? S.trEven : S.trOdd}>
                        <td style={{ ...S.td, fontWeight: 700, color: "#E6FF3E" }}>{s.sample}</td>
                        <td style={S.td}>{s.temp}</td>
                        <td style={S.td}>{s.viscosite}</td>
                        <td style={S.td}>{s.masse}</td>
                        <td style={S.td}>{s.eau}</td>
                        <td style={S.td}>{s.visuel}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Commentaires NOK */}
              {Number(details.PliesNOK) > 0 && (
                <>
                  <div style={S.sectionTitle}>
                    <span style={{ color: "#f87171" }}>⚠</span> Samples NOK — Commentaires
                  </div>
                  <div style={S.tableWrap} className="woodoo-scroll">
                    <table style={{ ...S.table, fontSize: 13 }}>
                      <thead>
                        <tr>
                          {["Sample", "Commentaire"].map(h => (
                            <th key={h} style={S.modalTh}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {details.SamplesComments?.map((c, i) => (
                          <tr key={i} className="woodoo-tr" style={{ background: "rgba(248,113,113,0.06)" }}>
                            <td style={{ ...S.td, fontWeight: 700, color: "#f87171" }}>{c.sample}</td>
                            <td style={{ ...S.td, textAlign: "left", color: "#fca5a5" }}>{c.commentaire}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              <button className="woodoo-btn-lime" style={S.closeBtn} onClick={() => setDetails(null)}>
                Fermer
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

/* ─────────────────────────────────────────────
   CSS GLOBAL
───────────────────────────────────────────── */
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  * { box-sizing: border-box; }
  body { font-family: 'Inter', sans-serif; }

  .woodoo-input {
    background: #0d2233 !important;
    color: #e2e8f0 !important;
    border: 1px solid #1e3a50 !important;
    transition: border-color 0.2s, box-shadow 0.2s !important;
    outline: none !important;
  }
  .woodoo-input:focus {
    border-color: #E6FF3E !important;
    box-shadow: 0 0 0 3px rgba(230,255,62,0.15) !important;
  }

  .woodoo-th:hover { background: #1e3a50 !important; color: #E6FF3E !important; }
  .woodoo-tr { transition: background 0.15s !important; }
  .woodoo-tr:hover td { background: #1a3248 !important; }

  .woodoo-voir { transition: background 0.2s, transform 0.15s, box-shadow 0.2s !important; }
  .woodoo-voir:hover {
    background: #fff !important; color: #000 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(230,255,62,0.3) !important;
  }

  .woodoo-edit { transition: background 0.2s, transform 0.15s !important; }
  .woodoo-edit:hover {
    background: #1d4ed8 !important;
    transform: translateY(-1px) !important;
  }

  .woodoo-btn-lime { transition: background 0.2s, transform 0.15s !important; }
  .woodoo-btn-lime:hover {
    background: #fff !important; transform: translateY(-1px) !important;
  }

  .woodoo-scroll::-webkit-scrollbar { height: 6px; width: 6px; }
  .woodoo-scroll::-webkit-scrollbar-track { background: #0d1b2a; }
  .woodoo-scroll::-webkit-scrollbar-thumb { background: #E6FF3E; border-radius: 3px; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .woodoo-spin { display: inline-block; animation: spin 1s linear infinite; }

  @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
  .woodoo-tr { animation: fadeIn 0.2s ease both; }

  @keyframes slideUp { from { opacity:0; transform:translateY(20px) scale(0.98); } to { opacity:1; transform:translateY(0) scale(1); } }
`;

/* ─────────────────────────────────────────────
   STYLES
───────────────────────────────────────────── */
const S = {
  page: { background: "linear-gradient(160deg,#041e2e 0%,#063549 60%,#052a3e 100%)", minHeight: "100vh", color: "#e2e8f0", fontFamily: "'Inter',sans-serif" },
  wrap: { padding: "24px 28px", maxWidth: 1400, margin: "0 auto" },

  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28, flexWrap: "wrap", gap: 16 },
  headerTitle: { fontSize: 28, fontWeight: 900, background: "linear-gradient(90deg,#fff 0%,#E6FF3E 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  headerSub: { fontSize: 13, color: "#94a3b8", marginTop: 4 },
  statsRow: { display: "flex", gap: 12 },
  statCard: { background: "rgba(255,255,255,0.04)", border: "1px solid #1e3a50", borderRadius: 12, padding: "12px 20px", textAlign: "center", backdropFilter: "blur(8px)" },
  statNum: { fontSize: 26, fontWeight: 900, color: "#fff" },
  statLabel: { fontSize: 11, color: "#94a3b8", marginTop: 2, textTransform: "uppercase", letterSpacing: "0.08em" },

  panel: { background: "rgba(255,255,255,0.03)", borderRadius: 16, border: "1px solid #1e3a50", padding: 24, backdropFilter: "blur(12px)" },

  searchWrap: { position: "relative", display: "flex", alignItems: "center", marginBottom: 16 },
  searchIcon: { position: "absolute", left: 14, fontSize: 15, zIndex: 1, pointerEvents: "none" },
  searchInput: { width: "100%", padding: "11px 40px 11px 40px", borderRadius: 10, fontSize: 14, fontWeight: 500 },
  searchClear: { position: "absolute", right: 12, background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 14, padding: "2px 6px", borderRadius: 4 },

  resultCount: { display: "flex", alignItems: "center", gap: 8, marginBottom: 14, fontSize: 13, fontWeight: 600, color: "#E6FF3E" },
  resultDot: { width: 8, height: 8, borderRadius: "50%", background: "#E6FF3E", boxShadow: "0 0 6px #E6FF3E" },

  loading: { textAlign: "center", padding: 40, fontSize: 16, color: "#94a3b8" },
  errMsg: { textAlign: "center", padding: 20, color: "#f87171", fontWeight: 600 },

  tableWrap: { overflowX: "auto", borderRadius: 12, border: "1px solid #1e3a50" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: { padding: "13px 16px", background: "#071e2f", color: "#94a3b8", fontWeight: 700, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.07em", whiteSpace: "nowrap", borderBottom: "1px solid #1e3a50", cursor: "default" },
  modalTh: { padding: "10px 14px", background: "#071e2f", color: "#94a3b8", fontWeight: 700, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.06em", borderBottom: "1px solid #1e3a50", textAlign: "center" },
  td: { padding: "11px 16px", borderBottom: "1px solid #0f2a3d", color: "#cbd5e1", textAlign: "center", whiteSpace: "nowrap" },
  tdIndex: { padding: "11px 16px", borderBottom: "1px solid #0f2a3d", color: "#64748b", fontSize: 11, fontWeight: 600, textAlign: "center" },
  tdLot: { color: "#E6FF3E", fontWeight: 700, fontFamily: "monospace", fontSize: 12 },
  trEven: { background: "transparent" },
  trOdd: { background: "rgba(255,255,255,0.015)" },

  nokBadge: { display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 20, fontWeight: 700, fontSize: 11, background: "rgba(248,113,113,0.15)", color: "#f87171", border: "1px solid rgba(248,113,113,0.3)" },
  okBadge: { display: "inline-flex", alignItems: "center", padding: "3px 10px", borderRadius: 20, fontWeight: 700, fontSize: 11, background: "rgba(74,222,128,0.15)", color: "#4ade80", border: "1px solid rgba(74,222,128,0.3)" },

  voirBtn: { padding: "6px 14px", borderRadius: 6, cursor: "pointer", background: "#E6FF3E", fontWeight: 700, border: "none", fontSize: 12, color: "#000" },
  editBtn: { padding: "6px 14px", borderRadius: 6, cursor: "pointer", background: "#2563eb", fontWeight: 700, border: "none", fontSize: 12, color: "#fff" },

  backdrop: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(4px)", display: "flex", justifyContent: "center", alignItems: "center", padding: 20, zIndex: 200 },
  modal: { background: "linear-gradient(160deg,#071e2f 0%,#0a2a40 100%)", color: "#e2e8f0", borderRadius: 20, padding: 28, width: "95%", maxWidth: 820, maxHeight: "90vh", overflowY: "auto", border: "1px solid #1e3a50", boxShadow: "0 25px 60px rgba(0,0,0,0.6)", animation: "slideUp 0.25s ease" },
  modalHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 },
  modalTitle: { fontSize: 20, fontWeight: 900, background: "linear-gradient(90deg,#fff,#E6FF3E)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  modalSub: { fontSize: 12, color: "#64748b", marginTop: 4, fontFamily: "monospace" },
  modalClose: { background: "rgba(255,255,255,0.08)", border: "1px solid #1e3a50", borderRadius: 8, color: "#94a3b8", cursor: "pointer", fontSize: 16, padding: "4px 10px" },

  infoRow: { display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 8 },
  infoChip: { flex: 1, minWidth: 120, background: "rgba(255,255,255,0.04)", border: "1px solid #1e3a50", borderRadius: 10, padding: "10px 14px", display: "flex", flexDirection: "column", gap: 4 },
  infoChipLabel: { fontSize: 10, color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.07em" },
  infoChipVal: { fontSize: 16, fontWeight: 800, color: "#fff" },

  sectionTitle: { fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: "#64748b", borderBottom: "1px solid #1e3a50", paddingBottom: 8, marginBottom: 12, marginTop: 24 },

  closeBtn: { width: "100%", marginTop: 24, padding: 14, borderRadius: 10, fontWeight: 900, fontSize: 14, background: "#E6FF3E", cursor: "pointer", border: "none", color: "#000", letterSpacing: "0.05em" },
};
